import React, { useState } from 'react';
import { Button, ChevronDown, ChevronUp, Mail01, Phone01 } from '@opendate-app/setlist';

const VISIBLE_ROW_COUNT = 5;

function SubscriptionsCard({ fanPermissions = {}, onEdit = () => {} }) {
  const [expanded, setExpanded] = useState(false);
  const subsByVenueOwnership = fanPermissions.mailkickSubscriptionsByVenueOwnership || {};
  const venueOwnerships = fanPermissions.venueOwnerships || [];
  const eventCountsByVenueOwnership = fanPermissions.calendarEventCountsByVenueOwnership || {};

  const rows = [...venueOwnerships]
    .map((venueOwnership) => {
      const subs = subsByVenueOwnership[venueOwnership.id] || {};
      return {
        id: venueOwnership.id,
        name: venueOwnership.venueable?.name || `Venue ${venueOwnership.id}`,
        email: !!subs.MARKETING_EMAIL,
        sms: !!subs.MARKETING_SMS,
        eventCount: eventCountsByVenueOwnership[venueOwnership.id] || 0,
      };
    })
    .sort((a, b) => b.eventCount - a.eventCount || a.name.localeCompare(b.name));

  const visibleRows = expanded ? rows : rows.slice(0, VISIBLE_ROW_COUNT);
  const hasMoreRows = rows.length > VISIBLE_ROW_COUNT;

  return (
    <div className="cdp-card">
      <div className="cdp-card-header-row">
        <h2 className="cdp-card-title">Subscriptions</h2>
        <Button variant="link-color" size="sm" onClick={onEdit} aria-label="Edit subscriptions">
          Edit
        </Button>
      </div>

      {rows.length === 0 ? (
        <div className="cdp-field-value">No subscriptions on file</div>
      ) : (
        visibleRows.map((row) => (
          <div key={row.id} className="cdp-side-row">
            <span className="cdp-side-row-label">{row.name}</span>
            <span className="cdp-side-row-value d-inline-flex align-items-center justify-content-end" style={{ gap: 10 }}>
              <span
                title={row.email ? 'Subscribed to email' : 'Not subscribed to email'}
                style={{ color: row.email ? 'var(--sl-fg-success)' : 'var(--sl-fg-quaternary)' }}
              >
                <Mail01 width={14} height={14} />
              </span>
              <span
                title={row.sms ? 'Subscribed to SMS' : 'Not subscribed to SMS'}
                style={{ color: row.sms ? 'var(--sl-fg-success)' : 'var(--sl-fg-quaternary)' }}
              >
                <Phone01 width={14} height={14} />
              </span>
            </span>
          </div>
        ))
      )}

      {hasMoreRows && (
        <div className="cdp-card-footer cdp-card-footer--center">
          <Button variant="link-gray" size="sm" onClick={() => setExpanded((prev) => !prev)}>
            <span className="cdp-see-more-label">
              {expanded ? 'Show less' : `Show all (${rows.length})`}
              {expanded ? <ChevronUp width={16} height={16} /> : <ChevronDown width={16} height={16} />}
            </span>
          </Button>
        </div>
      )}
    </div>
  );
}

export default SubscriptionsCard;
